import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=366dc68d&"
import script from "./ActionButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports